import React from 'react';

export const MyFinancing = React.lazy(() => import('./pages/MyFinancing'));
